import { createSlice } from '@reduxjs/toolkit';
import { VOICE_INPUT_IDLE, VOICE_INPUT_AWAITING_PERMISSION, VOICE_INPUT_RECORDING, VOICE_INPUT_ERROR, VOICE_INPUT_ERROR_PERMISSION_DENIED } from '../constants/voiceInputConstants';
const initialState = {
  status: VOICE_INPUT_IDLE,
  errorType: null
};
const voiceInputSlice = createSlice({
  name: 'voiceInput',
  initialState,
  reducers: {
    requestVoiceRecording(state) {
      state.status = VOICE_INPUT_AWAITING_PERMISSION;
      state.errorType = null;
    },
    voiceRecordingStarted(state) {
      if (state.status !== VOICE_INPUT_AWAITING_PERMISSION) return;
      state.status = VOICE_INPUT_RECORDING;
    },
    voiceMicPermissionError(state) {
      if (state.status !== VOICE_INPUT_AWAITING_PERMISSION) return;
      state.status = VOICE_INPUT_ERROR;
      state.errorType = VOICE_INPUT_ERROR_PERMISSION_DENIED;
    },
    cancelVoiceRecording(state) {
      state.status = VOICE_INPUT_IDLE;
      state.errorType = null;
    }
  }
});
export const {
  requestVoiceRecording,
  voiceRecordingStarted,
  voiceMicPermissionError,
  cancelVoiceRecording
} = voiceInputSlice.actions;
export default voiceInputSlice.reducer;